import axios from "axios";

let startLoadingGlobal = null;
let endLoadingGlobal = null;

export const setupAxios = (loaderApi) => {
  if (typeof loaderApi === "function") {
    startLoadingGlobal = () => loaderApi(true);
    endLoadingGlobal = () => loaderApi(false);
    return;
  }
  startLoadingGlobal = loaderApi?.startRequest || null;
  endLoadingGlobal = loaderApi?.endRequest || null;
};

const REMOTE_FALLBACK_BASE_URL = "https://school-management-system-backend-ee77.onrender.com";

function resolveApiBaseUrl() {
  const fromEnv = String(process.env.REACT_APP_API_URL || "").trim();
  if (typeof window === "undefined") {
    return fromEnv || REMOTE_FALLBACK_BASE_URL;
  }

  const host = window.location.hostname;
  const isLocalNetwork =
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "[::1]" ||
    /^192\.168\.\d{1,3}\.\d{1,3}$/.test(host) ||
    /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(host) ||
    /^172\.(1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3}$/.test(host);

  if (isLocalNetwork) {
    if (host === "localhost" || host === "127.0.0.1" || host === "[::1]") {
      return fromEnv || "http://localhost:5001";
    }
    return fromEnv && !/localhost|127\.0\.0\.1/i.test(fromEnv)
      ? fromEnv
      : `http://${host}:5001`;
  }

  return fromEnv || REMOTE_FALLBACK_BASE_URL;
}

const api = axios.create({
  baseURL: resolveApiBaseUrl(),
});

/* REQUEST */
api.interceptors.request.use((config) => {

  if (!config.skipGlobalLoader && startLoadingGlobal) startLoadingGlobal();

  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

/* RESPONSE */
api.interceptors.response.use(
  (response) => {
    if (!response.config?.skipGlobalLoader && endLoadingGlobal) {
      endLoadingGlobal();
    }
    return response;
  },
  (error) => {

    if (!error.config?.skipGlobalLoader && endLoadingGlobal) {
      endLoadingGlobal();
    }

    /* AUTO LOGOUT — not on login (401 = bad credentials, must stay on login page) */
    if (error.response?.status === 401) {
      const reqUrl = String(error.config?.url || "");
      const isPublicAuth =
        reqUrl.includes("/api/auth/login") ||
        reqUrl.endsWith("/auth/login") ||
        reqUrl.includes("/api/auth/forgot-password") ||
        reqUrl.includes("/api/auth/setup-password");
      if (!isPublicAuth) {
        localStorage.removeItem("token");
        window.location.href = "/";
      }
    }

    return Promise.reject(error);
  }
);

export default api;